import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "@/components/common/Image";
import Icon from "@/components/icon/Icon";
import { Sizes, Window_2px } from "@/components/icon/IconList";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Box, Typography, styled } from "@mui/material";
import Link from "next/link";
import { useBrandStore } from "../BrandProvider";
const BrandAbout = ()=>{
    const { introduction , biography , speciality , snsItems , introduceImageUrlItems  } = useBrandStore((state)=>state.brand);
    return /*#__PURE__*/ _jsxs(AboutContainer, {
        children: [
            /*#__PURE__*/ _jsxs(ItemBox, {
                children: [
                    /*#__PURE__*/ _jsx(TypoTitle, {
                        children: "브랜드 소개"
                    }),
                    /*#__PURE__*/ _jsx(TypoBody, {
                        children: introduction !== null && introduction !== void 0 ? introduction : ""
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ItemBox, {
                children: [
                    /*#__PURE__*/ _jsx(TypoTitle, {
                        children: "약력"
                    }),
                    /*#__PURE__*/ _jsx(TypoBody, {
                        children: biography === null || biography === void 0 ? void 0 : biography.split("\n").map((text, index)=>/*#__PURE__*/ _jsx(Typography, {
                                component: "span",
                                children: text
                            }, text))
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ItemBox, {
                children: [
                    /*#__PURE__*/ _jsx(TypoTitle, {
                        children: "전문 분야"
                    }),
                    /*#__PURE__*/ _jsx(TypoBody, {
                        children: speciality === null || speciality === void 0 ? void 0 : speciality.split("\n").map((text, index)=>/*#__PURE__*/ _jsx(Typography, {
                                component: "span",
                                children: text
                            }, text))
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ItemBox, {
                children: [
                    /*#__PURE__*/ _jsx(TypoTitle, {
                        children: "웹사이트 및 SNS"
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        sx: (theme)=>({
                                display: "grid",
                                gap: "12px",
                                padding: "20px 0",
                                gridTemplateColumns: "1fr 1fr",
                                [theme.breakpoints.down("sm")]: {
                                    flexDirection: "column",
                                    gridTemplateColumns: "1fr"
                                }
                            }),
                        children: snsItems === null || snsItems === void 0 ? void 0 : snsItems.map((item, index)=>/*#__PURE__*/ _jsxs(Link, {
                                href: item.url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                onClick: ()=>{
                                    //mx-196
                                    mixpanelEvent("Link Button Clicked", {
                                        "Button Type": "웹사이트 및 SNS",
                                        "Button Name": item.title,
                                        "Button Url": item.url,
                                        Position: "Brand Home"
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "subtitle1",
                                        children: [
                                            item.title,
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Icon, {
                                        icon: Window_2px,
                                        size: Sizes.small
                                    })
                                ]
                            }, item.url))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ItemBox, {
                children: introduceImageUrlItems === null || introduceImageUrlItems === void 0 ? void 0 : introduceImageUrlItems.map((item, index)=>/*#__PURE__*/ _jsx(Image, {
                        src: item,
                        alt: "brand introduce images",
                        width: 0,
                        height: 0,
                        sizes: "100%",
                        style: {
                            width: "100%",
                            height: "auto"
                        }
                    }, item))
            })
        ]
    });
};
const AboutContainer = styled("section")((param)=>{
    let { theme  } = param;
    return {
        width: "100%"
    };
});
const ItemBox = styled("div")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        position: "relative",
        // padding: '40px 0',
        "&:not(:first-of-type)": {
            borderTop: "1px solid ".concat(theme.palette.grey[50]),
            padding: "40px 0",
            [theme.breakpoints.down("lg")]: {
                padding: "32px",
                "&:last-of-type": {
                    padding: "20px 0"
                }
            },
            [theme.breakpoints.down("sm")]: {
                padding: "20px"
            }
        },
        a: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 20px",
            borderRadius: "6px",
            border: "1px solid ".concat(theme.palette.grey[200]),
            "&:hover": {
                backgroundColor: theme.palette.grey[50]
            },
            [theme.breakpoints.down("sm")]: {
                width: "100%"
            }
        },
        [theme.breakpoints.down("lg")]: {
            padding: "0 32px",
            "&:last-of-type": {
                padding: "20px 0"
            }
        },
        [theme.breakpoints.down("sm")]: {
            padding: "0 20px"
        }
    };
});
export const TypoTitle = styled(Typography)((param)=>{
    let { theme  } = param;
    return {
        ...theme.typography.h5,
        [theme.breakpoints.down("sm")]: {
            ...theme.typography.h6
        }
    };
});
const TypoBody = styled(Typography)((param)=>{
    let { theme  } = param;
    return {
        whiteSpace: "pre-line",
        ...theme.typography.body1,
        color: theme.palette.text.secondary,
        padding: "20px 0",
        span: {
            display: "block"
        }
    };
});
export default BrandAbout;
